function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/speed-master-bronze");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "7.03125e-05 6.95652174e-05 45.0000703 6.95652174e-05 45.0000703 48 7.03125e-05 48"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-480.000000, -393.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/speed-master-bronze",
  transform: "translate(480.000000, 393.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-23"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-19"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-18"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5000703,48.0000696 L22.5000703,48.0000696 C10.0737422,48.0000696 7.03125e-05,38.0334609 7.03125e-05,25.7392 L7.03125e-05,4.17398261 C7.03125e-05,1.86893913 1.88901563,6.95652174e-05 4.21882031,6.95652174e-05 L40.7813203,6.95652174e-05 C43.111125,6.95652174e-05 45.0000703,1.86893913 45.0000703,4.17398261 L45.0000703,25.7392 C45.0000703,38.0334609 34.9263984,48.0000696 22.5000703,48.0000696",
  id: "Fill-17",
  fill: "#AF825D",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.5000703,44.5218087 L22.5000703,44.5218087 C10.0737422,44.5218087 7.03125001e-05,34.5552 7.03125001e-05,22.2609391 L7.03125001e-05,4.17398261 C7.03125001e-05,1.86893913 1.88901563,6.95652174e-05 4.21882031,6.95652174e-05 L40.7813203,6.95652174e-05 C43.111125,6.95652174e-05 45.0000703,1.86893913 45.0000703,4.17398261 L45.0000703,22.2609391 C45.0000703,34.5552 34.9263984,44.5218087 22.5000703,44.5218087",
  id: "Fill-20",
  fill: "#E5B389"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813203,6.95652174e-05 L4.21882031,6.95652174e-05 C1.88901563,6.95652174e-05 7.03125001e-05,1.86893913 7.03125001e-05,4.17398261 L7.03125001e-05,22.2609391 C7.03125001e-05,34.5552 10.0733906,44.5218087 22.5000703,44.5218087 L22.5000703,44.5218087 C34.9263984,44.5218087 45.0000703,34.5552 45.0000703,22.2609391 L45.0000703,4.17398261 C45.0000703,1.86893913 43.111125,6.95652174e-05 40.7813203,6.95652174e-05 M40.7813203,4.17398261 L40.7813203,22.2609391 C40.7813203,32.2341565 32.5804219,40.3478957 22.5000703,40.3478957 C12.4197188,40.3478957 4.21882031,32.2341565 4.21882031,22.2609391 L4.21882031,4.17398261 L40.7813203,4.17398261",
  id: "Fill-22",
  fill: "#CF9C6D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7609687,9.96932174 L15.7609687,23.2465391 C15.7609687,23.6305391 16.0756172,23.9421913 16.4640937,23.9421913 L19.1011641,23.9421913 C19.4896406,23.9421913 19.8042891,24.2534957 19.8042891,24.6378435 L19.8042891,33.3703652 C19.8042891,34.0806261 20.7531562,34.3345391 21.1149141,33.7209739 L28.6221797,20.9877565 C28.8956953,20.5241043 28.5574922,19.9414957 28.0150312,19.9414957 L24.9856172,19.9414957 C24.4628437,19.9414957 24.1228828,19.3974957 24.3566719,18.934887 L28.7304609,10.2806261 C28.96425,9.81801739 28.6239375,9.27366957 28.1015156,9.27366957 L16.4640937,9.27366957 C16.0756172,9.27366957 15.7609687,9.58532174 15.7609687,9.96932174",
  id: "Fill-24",
  fill: "#AF825D"
})))));

var SvgSpeedMasterBronze = function SvgSpeedMasterBronze(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeedMasterBronze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speed-master-bronze.398a3df1.svg";
export { ForwardRef as ReactComponent };